export default __webpack_public_path__ + "static/media/uniid_icon.c900896f.svg";